let channels = {
    'alipay': {
        option: 'alipay',
        tradeType: 'WAP',
        open: true
    },
    'wxpay': {
        option: 'wxpay',
        tradeType: 'NATIVE',
        open: true
    },
    'paypal': {
        option: 'paypal',
        tradeType: 'WAP',
        open: true
    },
    'onecard': {
        option: 'onecard',
        tradeType: 'WAP',
        open: true
    },
    'bj_mycard': {
        option: 'bj_mycard',
        tradeType: 'WAP',
        open: true
    },
    bk_card: {
        open: true,
        text: 'bk_card',
        option: 'bk_card'
    },
    bk_atm: {
        open: true,
        text: 'bk_atm',
        option: 'bk_atm'
    },
    'vip': { // 中东VIP
        text: 'Vodafone cash',
        option: 'vip',
        open: true
    },
    'vipcz': { // 台湾＋国内VIP
        text: 'vipcz',
        option: 'vipcz',
        open: true
    },
    'sinopac_atm': {
        text: 'sinopac_atm',
        option: 'sinopac_atm',
        open: true
    },
    'xenopay': {
        text: 'XenoPay',
        option: 'xenopay',
        open: false
    },
    'codapay': {
        text: 'codapay',
        option: 'codapay',
        open: true
    },
    // 泰国cashcard
    pepay_entitycard_thb: {
        text: 'CashCard(THB)',
        option: 'pepay_entitycard_thb',
        open: true
    },
    zalo: {
        open: false,
        option: 'zalo',
    },
    momo: {
        open: true,
        option: 'momo',
    },
    danalpay: {
        open: true,
        option: 'danalpay',
        text: 'danalpay'
    },
    //  新增的两种印度充值方式: molpay_points; paytm
    molpay_points: {
        open: true,
        text: 'molpay_points',
        option: 'molpay_points'
    },
    paytm: {
        open: true,
        text: 'paytm',
        option: 'paytm'
    },
    // VN的充值方式
    pepay_onlinebank_vnd: {
        open: true,
        text: 'pepay_onlinebank_vnd',
        option: 'pepay_onlinebank_vnd'
    },
    pepay_entitycard_vnd: {
        open: true,
        text: 'pepay_onlinebank_vnd',
        option: 'pepay_entitycard_vnd'
    },
    //印尼充值方式
    pepay_alfamart_idr: {
        open: true,
        text: 'Alfamart',
        option: 'pepay_alfamart_idr'
    },
    pepay_webatm_idr: {
        open: true,
        text: 'Bank Atm',
        option: 'pepay_webatm_idr'
    },
    codapay_id: {
        open: true,
        text: 'Direct Carrier Billing',
        option: 'codapay_1'
    },
    codapay_1: {
        open: true,
        text: 'Direct Carrier Billing',
        option: 'codapay_1'
    },
    codapay_220: {
        open: true,
        text: 'ATM Transfer',
        option: 'codapay_220'
    },
    codapay_221: {
        open: true,
        text: 'Alfamart',
        option: 'codapay_221'
    },
    codapay_223: {
        open: true,
        text: 'Doku Wallet',
        option: 'codapay_223'
    },
    codapay_224: {
        open: true,
        text: '7-Eleven',
        option: 'codapay_224'
    },
    codapay_226: {
        open: true,
        text: 'Indomaret',
        option: 'codapay_226'
    },
    codapay_227: {
        open: true,
        text: 'GO-PAY',
        option: 'codapay_227'
    },
    //菲律宾充值方式
    codapay_ph: {
        open: true,
        text: 'Bank Payments',
        option: 'codapay_250'
    },
    codapay_250: {
        open: true,
        text: 'Bank Payments',
        option: 'codapay_250'
    },
    codapay_251: {
        open: true,
        text: 'Counter Payments',
        option: 'codapay_251'
    },
    codapay_252: {
        open: true,
        text: 'GCash',
        option: 'codapay_252'
    },
    codapay_253: {
        open: true,
        text: '7-Eleven PH',
        option: 'codapay_253'
    },
    icard: {
        open: true,
        text: 'iCard',
        option: 'icard'
    },
    kakaopay: {
        open: true,
        text: 'Kakao pay',
        option: 'kakaopay'
    },
    pepay: {
        open: true,
        text: 'pepay',
        option: 'pepay'
    },
    gash: {
        open: true,
        text: 'GASH',
        option: 'gash'
    },
    gash_card: {
        open: true,
        text: 'GASH Card',
        option: 'gash_card'
    },
    // 印度
    codapay_390: {
        open: true,
        text: 'Paytm Wallet',
        option: 'codapay_390'
    },
    codapay_391: {
        open: true,
        text: 'Bank Transfer',
        option: 'codapay_391'
    },
    pepay_credit: {
        name: 'pepay_credit',
        text: 'pepay_credit',
        option: 'pepay_credit',
        open: true,
    },

    pepay_store: {
        text: 'pepay_store',
        option: 'pepay_store',
        open: true,
    },
    
    pepay_store_ibon_twd: {
        text: 'ibon便利生活站',
        option: 'pepay_store_ibon_twd',
        open: true,
    },
    pepay_store_fami_twd: {
        text: '全家FAMIPORT',
        option: 'pepay_store_fami_twd',
        open: true,
    },
    pepay_store_hilifeet_twd: {
        text: '萊爾富Life-ET',
        option: 'pepay_store_hilifeet_twd',
        open: true,
    },
    pepay_store_okgo_twd: {
        text: 'OK超商OK-go',
        option: 'pepay_store_okgo_twd',
        open: true,
    },
    
    dokypay: {
        text: 'DokyPay',
        option: 'dokypay',
        open: true,
    },
}

export default channels;


// WEBPACK FOOTER //
// ./js/component/recharge/config.js